import { roadMapBridge } from '../render/roadMapBridge';
import { stampBlocks } from '../render/roadMap';

// Sited venues' shells (VenueShells) stamped into the road map as buildings, so
// everything that reads the map — where people stand and walk (city/cityPath),
// where a scene's camera may go (city/sceneShots), what muffles a voice — sees
// the Corner Market as the building it is, not the open lot under it.
//
// The map is rebuilt from the city model now and then (StreetLights); each new
// one is stamped again and published in its place. A stamped map is marked so
// it is not stamped twice.

let raw = null;                 // the latest map as photographed
const shells = new Map();       // roomId → { minX, maxX, minZ, maxZ }

function republish() {
  if (!raw || !shells.size) return;
  const stamped = stampBlocks(raw, [...shells.values()]);
  stamped.stampedFrom = raw;
  roadMapBridge.publish(stamped);
}

roadMapBridge.subscribe((m) => {
  if (!m || m.stampedFrom) return;
  raw = m;
  republish();
});

/** A sited venue's shell footprint (world AABB), or null when it is gone. */
export function setShellFootprint(roomId, box) {
  const prev = shells.get(roomId);
  if (!box) { if (prev) { shells.delete(roomId); if (raw) roadMapBridge.publish(shells.size ? Object.assign(stampBlocks(raw, [...shells.values()]), { stampedFrom: raw }) : raw); } return; }
  if (prev && Math.abs(prev.minX - box.minX) < 0.05 && Math.abs(prev.maxX - box.maxX) < 0.05 && Math.abs(prev.minZ - box.minZ) < 0.05 && Math.abs(prev.maxZ - box.maxZ) < 0.05) return;
  shells.set(roomId, box);
  console.log(`[shell] ${roomId} stamped into the street map: x ${box.minX.toFixed(1)}..${box.maxX.toFixed(1)} · z ${box.minZ.toFixed(1)}..${box.maxZ.toFixed(1)}`);
  republish();
}
